import { z } from 'zod';

import { zodCallOffResponseSchema } from '../validations';

// Request payload schema for duplicating a call-off
export const zodDuplicateCallOffPayloadSchema = z.object({
  includeItems: z.boolean().default(true),
  newCalloffNumber: z.string().max(100).nullish(),
  newDeliveryDate: z.iso.date(),
});

// Response schema for duplicated call-off (re-export from shared)
export { zodCallOffResponseSchema as zodDuplicateCallOffResponseSchema };
